module.exports = __webpack_public_path__ + "img/flower_leaf_16.30297067.png";